export default function emailReply (data) {
  let newData = this.dataGet("view/customData").toJS();
  newData.replyMode = data.replyMode;

  this.openEmailPopup(newData);
}